import { useEstateItems } from "@/shared/hooks/useEstateItems";
import { useItemAction } from "@/shared/hooks/useItemAction";

export function useEstateItemActions(estateId: number | null | undefined) {
  const estateItems = useEstateItems(estateId);
  const itemActions = useItemAction({
    approveItem: estateItems.approveItem,
    declineItem: estateItems.declineItem,
  });
  return { ...estateItems, itemActions };
}
